import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import styled from 'styled-components';

import CardFlag from '../components/CardFlag';
import { rem, colors } from '../lib/global-styles';

export const InputWrapper = styled.div`
  margin-bottom: ${rem(8)};
  position: relative;

  label {
    font-size: ${rem(16)};
    letter-spacing: ${rem(0.12)};
    line-height: ${rem(14)};
    color: ${colors.darkGrey};
    display: block;
    margin-bottom: ${rem(8)};
    text-align: left;
  }

  input {
    border: 1px solid ${colors.grey};
    border-radius: ${rem(5)};
    background: ${colors.white};
    padding: ${rem(14)} ${rem(12)};
    font-size: ${rem(16)};
    color: ${colors.darkGrey};
    letter-spacing: ${rem(0.16)};
    line-height: ${rem(20)};
    width: 100%;
    box-sizing: border-box;
    margin-bottom: ${rem(8)};
  }

  .flag-image {
    max-width: ${rem(24)};
    position: absolute;
    top: ${rem(35)};
    right: ${rem(30)};
  }
`;

class FormGroup extends Component {
  render() {
    const {
      id,
      name,
      label,
      placeholder,
      onChangeValue,
      value,
      mask,
      type,
      readOnly,
      autoComplete,
      onBlurValue,
    } = this.props;

    if (mask) {
      return (
        <InputWrapper>
          <label htmlFor={id}>{label}</label>
          <InputMask
            id={id}
            name={name}
            type={type}
            readOnly={readOnly}
            mask={mask}
            formatChars={{ '9': '[0-9]', '?': '[0-9]' }}
            maskChar=" "
            onChange={onChangeValue}
            value={value || ''}
            onFocus={this.onFocus}
            onBlur={onBlurValue}
            autoComplete={autoComplete}
            data-lpignore="true"
            placeholder={placeholder}
          />
          {id === 'card-number' ? <CardFlag className="flag-image" cardNumber={value} /> : null}
          {id === 'card-cvv' ? '' : null}

          {this.props.children}
        </InputWrapper>
      );
    } else {
      return (
        <InputWrapper>
          <label htmlFor={id}>{label}</label>
          <input
            id={id}
            name={name}
            type={type}
            readOnly={readOnly}
            onChange={onChangeValue}
            value={value || ''}
            onFocus={this.onFocus}
            onBlur={onBlurValue}
            autoComplete="off"
            placeholder={placeholder}
          />
        </InputWrapper>
      );
    }
  }
}

FormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChangeValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  mask: PropTypes.string,
  type: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  autoComplete: PropTypes.string,
};

export default connect()(FormGroup);
